<span
  [rtTooltip]="time | amDateFormat: amDateFormatPattern"
  [rtTooltipPosition]="tooltipPosition"
  [attr.text-darkest]="colorDarkest ? '' : null"
>
  <ng-container *ngIf="prefix"> {{ prefix }} </ng-container>
  {{ time | rtTimeAgo: timeAgoOptions }}
</span>
